import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class BackupServico extends Servico {
  constructor() {
    super('backup')
  }

  recuperarBackup() {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/download`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default BackupServico
